import { ChevronRight } from "@assets";
import { Row } from "@components/Flex";
import { Body } from "@components/Typography";
import { useStyles } from "./styles";
import { ListItemProps } from "./types";

export const ListItem = ({
  title,
  subtitle,
  onClick,
  leftIcon,
  titleIcon,
  rightIcon = <ChevronRight />,
  style,
  disabled = false,
  hidden = false,
}: ListItemProps) => {
  const styles = useStyles();

  if (hidden) {
    return null;
  }

  return (
    <div
      style={{ ...styles.container, ...style }}
      onClick={() => {
        if (!disabled) {
          onClick?.();
        }
      }}
    >
      <Row>
        {leftIcon}
        <div style={styles.left}>
          <Row style={styles.titleRow}>
            <Body>{title}</Body>
            {titleIcon}
          </Row>
          <Body style={styles.subtitle}>{subtitle}</Body>
        </div>
        {rightIcon}
      </Row>
    </div>
  );
};
